// extracted by css-extract-rspack-plugin
export default {"itemTitle":"_4293275f","itemDetailText":"_a1dca413","heartPill":"_c6dbeeb9","featuredInDivider":"_345055dc"};